module.exports = __webpack_public_path__ + "static/bm-f1af119a7c86d87e2d5f305337adcff6.svg";